import { Box, SxProps, Theme } from '@mui/material';
import { BreadcrumbBar } from 'components/Foundation/BreadcrumbBar';
import { Footer } from 'components/Foundation/Footer';
import { Header } from 'components/Foundation/Header';

export interface PageWrapperProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const PageWrapper: React.FC<PageWrapperProps> = ({ children, sx }) => {
  return (
    <Box display="flex" minHeight="100vh" justifyContent="space-between" flexDirection="column" sx={{ overflowX: 'hidden' }}>
      <Box>
        <Header />
        <BreadcrumbBar />
      </Box>
      <Box
        sx={{
          marginBottom: 'auto',
          marginTop: 4,
          paddingX: { xs: 2, lg: 15 },
          paddingBottom: { xs: 5, lg: 8 },
          ...sx,
        }}
      >
        {children}
      </Box>
      {/* Footer owns its own site_width / side gutters (matches live Fusion footer). */}
      <Footer />
    </Box>
  );
};
